import axios from "axios";

export default {
  async create(formData) {

    const files = new FormData();
    for (let i=0; i<formData.files.length; i+=1) {
      files.append("files", formData.files[i]);
    }
    files.append("data", JSON.stringify(formData.formData));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(`/medias`, files, config);
  },
  async update(formData) {
    const files = new FormData();
    for (let i=0; i<formData.files.length; i+=1) {
      files.append("files", formData.files[i]);
    }
    files.append("data", JSON.stringify(formData.formData));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.put(`/medias/${formData.id}`, files, config);
  },
  async findAll() {
    return axios.get(`/medias`);
  },
  async findOne(id) {
    return axios.get(`/medias/${id}`);
  },
  async delete({ id }) {
    return axios.delete(`/medias/${id}`);
  }
};